import React from "react";
import {
  ExpandableSection,
  Header,
  SpaceBetween,
  TextContent,
} from "@amzn/awsui-components-react";

interface ExpandableDbdSectionProps {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  expanded: boolean;
  onChange: (event: { detail: { expanded: boolean } }) => void;
  children?: React.ReactNode;
  variant?: "container" | "footer" | "default";
  isEmpty?: boolean;
  emptyMessage?: string;
  headerActions?: React.ReactNode;
}

export function ExpandableDbdSection({
  title,
  description,
  expanded,
  onChange,
  children,
  variant = "container",
  isEmpty = false,
  emptyMessage = "No data available",
  headerActions,
}: ExpandableDbdSectionProps) {
  return (
    <ExpandableSection
      variant={variant}
      expanded={expanded}
      onChange={onChange}
      header={
        <Header variant="h3" actions={headerActions}>
          {title}
          {description && (
            <TextContent>
              <small>{description}</small>
            </TextContent>
          )}
        </Header>
      }
    >
      <SpaceBetween size="l">
        {isEmpty ? (
          <TextContent>
            <small>{emptyMessage}</small>
          </TextContent>
        ) : (
          children
        )}
      </SpaceBetween>
    </ExpandableSection>
  );
}
